import React from 'react';
import { observer } from 'mobx-react';
import { StopCardRow } from '@routific/hive';
import OrderStatus from '../../../../../shared/OrderStatus';
import { VisitDtoModelType } from '../../../../../../store/mst/models';
import { useStore } from '../../../../../../store/mst';
import { IColor } from '../../../../../../types/IColor';

interface Props {
  order: VisitDtoModelType;
  parentStopId?: string;
  color?: IColor;
  isBreakdownLoading?: boolean;
}

const OrderCard: React.FunctionComponent<Props> = ({
  order,
  parentStopId,
  color,
  isBreakdownLoading = false,
}) => {
  const { ui } = useStore();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    ui.selectOrderAndStopByUuid(!order?.isSelected ? order.uuid : undefined, parentStopId);
  };

  const handleMouseEnter = () => {
    ui.hoverVisit(order.id);
  };

  const handleMouseLeave = () => {
    ui.hoverVisit(null);
  };

  // Product decision: only show customer-facing order number; do not fallback to internal IDs.
  const orderNumber = order.customerOrderNumber;

  return (
    <StopCardRow
      data-cy="order-status"
      data-testid="order-status"
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <OrderStatus
        loading={!!order.isBeingModified || isBreakdownLoading}
        visit={order}
        stopUuid={parentStopId}
        color={color}
        orderNumber={orderNumber}
      />
    </StopCardRow>
  );
};

export default observer(OrderCard);
